import { render } from "./CertiComponent.vue?vue&type=template&id=1823ac79&scoped=true"
import script from "./CertiComponent.vue?vue&type=script&lang=js"
export * from "./CertiComponent.vue?vue&type=script&lang=js"

import "./CertiComponent.vue?vue&type=style&index=0&id=1823ac79&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1823ac79"]])

export default __exports__